// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1paNq","name":"styles_name__2Ye8P","phone":"styles_phone__1GO_X"};